/**
 * @description 合同-法人信息字段
 */
import { formatPics, picDataFormat, filterParams } from '@/common/utils/format'
import { i18n, getBDCountry, sprintf } from '@/common/utils/i18n'
const country = getBDCountry() || 'MX'

// 对后端接口下发的数据做格式转换
export function revert (data = {}) {
  const { contractGlobal } = data
  return {
    legalName: contractGlobal.legalName || '',
    legalType: contractGlobal.legalType === 0 ? null : contractGlobal.legalType,
    legalId: contractGlobal.legalId || '',
    legalPics: formatPics(contractGlobal.legalPics),
    legalExtra: picDataFormat(contractGlobal.legalExtra, contractGlobal.legalExtra)
  }
}

export function submitFormat (contractGlobal) {
    return {
      params: JSON.stringify({
        source: 'contractor',
        queryId: this.$route.params.id,
        contractGlobal: contractGlobal
      })
    }
  }

export default {
  revert,
  submitFormat
}
